// Mark assets as loaded
window.ahaLoaded = true;

if (window.overrideAssetHost) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = window.overrideAssetHost;
}

import 'core-js';
import 'iripo';
const requireAll = r =>
  r
    .keys()
    .filter(key => !key.includes('.test.'))
    .forEach(r);

// Require styles.
import '@aha-app/aha-icon';
import '@aha-app/aha-base/dist-vars/variables.css';
import '@aha-app/aha-base/dist/assets/font-awesome/index.css';

// Import AhaBase library, which defines a number of basic styles for common and cross-property components.
import '@aha-app/aha-base/dist/index.less';

//  Require styles.
import './idea_portals_styles';

//  Require vendor dependencies.
import 'javascripts/jquery-ui-1.13.2.custom';
import 'javascripts/bootstrap-plugins';
import 'javascripts/aha-tooltip';
import Turbolinks from 'javascripts/turbolinks';
window.Turbolinks = Turbolinks;

//  Require npm dependencies.
import '@aha-app/bootstrap-datepicker';
import '@aha-app/selectro';
import 'jquery-ujs';

//  Require local assets.
import 'javascripts/templates';
import 'javascripts/classic_portals_callbacks';
requireAll(require.context('javascripts/idea_portals', false, /\.(js|ts)$/));
requireAll(
  require.context('javascripts/idea_portals/old_theme', false, /\.(js|ts)$/)
);

// Initialize listener to mount React components on pageload/navigation.
import SelectroV2 from '@aha-app/selectro-v2';
import { addListener } from 'javascripts/react_mount';
import { AhaEditorFieldV2 } from 'components/aha_editor_field_v2/LazyAhaEditorFieldV2';
import { AhaNewRecordEditor } from 'components/aha_new_record_editor/LazyAhaNewRecordEditor';

const components = {
  AhaEditorFieldV2: () => AhaEditorFieldV2,
  AhaEditorCustomFieldValueV2: () => AhaEditorFieldV2,
  AhaNewRecordEditor: () => AhaNewRecordEditor,

  SelectroV2: () => SelectroV2,
};
addListener(components);

import { defineCustomElements } from '@aha-app/aha-base/dist/components';
defineCustomElements();
